import O1HD from "../../engines/gameEngine";
import utilsView from "../../engines/libs/utilsView";
import { UI_Z_INDEX } from "../../engines/modules/uiModule";
import { CsvFileKind } from "../../modes/define/CsvFileKind";
import { MessageEventKind } from "../../modes/define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../../modes/normalMode/BundleResourceConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class concubineCompletePage extends cc.Component {

    @property({type:cc.Node,tooltip:"盖头节点"})
    lidNode:cc.Node = null;

    @property({type:cc.Sprite,tooltip:"女生图片"})
    womenSp:cc.Sprite = null;

    @property({type:cc.SpriteFrame,tooltip:"美女图片"})
    beautySp:cc.SpriteFrame = null;

    @property({type:cc.SpriteFrame,tooltip:"丑女图片"})
    uglySp:cc.SpriteFrame = null;

    @property({type:cc.Node,tooltip:"乌鸦节点"})
    ravenNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"光效节点"})
    lightNode:cc.Node = null;

    concubineType:number = 0;

    start(){
        O1HD.on(MessageEventKind.EventName.CLOSE_CONCUBINE,this.closeThis,this);
        O1HD.on(MessageEventKind.EventName.CLOSE_SELECT_CONCUBINE,this.closeThis,this);
        this.lidNode.on('touchmove',this.onTouchMoveLid,this);
    }

    bindType(type:number){
        this.concubineType = type;
        this.loadPage();
    }

    loadPage(){
        switch(this.concubineType){
            case 0:{
                this.womenSp.spriteFrame = this.beautySp;
                break;
            }
            case 1:{
                this.womenSp.spriteFrame = this.uglySp;
                break;
            }
            
        }
    }

    //滑动盖头
    onTouchMoveLid(e:cc.Event.EventTouch){
        let start:cc.Vec2 = e.getStartLocation();
        let local :cc.Vec2 = e.getLocation();

        if(local.y - start.y > 30){
            this.lidNode.off('touchmove',this.onTouchMoveLid,this);
            cc.tween(this.lidNode).to(0.1,{opacity:0}).delay(1).call(()=>{
                let eventId:string = null;
                switch(this.concubineType){
                    case 0:{
                        eventId = "50";
                        this.lightNode.active = true;
                        O1HD.getManagers().soundMgr.playSound("beautyWoman",null,BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
                        break;
                    }
                    case 1:{
                        eventId = "49";
                        this.ravenNode.active = true;
                        cc.tween(this.ravenNode).delay(0.2).call(()=>{
                            O1HD.getManagers().soundMgr.playSound("uglyWoMan",null,BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
                        }).to(4,{x:-450}).start();
                        break;
                    }
                    default:{
                        eventId = "50";
                        this.lightNode.active = true;
                        break;
                    }
                }
                this.scheduleOnce(()=>{
                    if(eventId != null){
                        O1HD.getManagers().soundMgr.playSound("win",null,BUNDLE_SMALL_NAME.chooseConcubineGameBundle);
                        let data = {
                            id: eventId
                            , eventCsv: CsvFileKind.CsvFile.MAIN_EVENT
                            , eventArrCsv: CsvFileKind.CsvFile.MAIN_EVENT_ARRAY                    
                            , saveData: ()=> {
                            
                            }
                            , exitLayer: ()=> {
                                this.closeThis();
                            }
                        }
                        utilsView.openEventLayer(
                            null
                            , data
                            , UI_Z_INDEX.DIALOG
                        );
                    }
                },2);
            }).start();
        }
    }

    closeThis(){
        O1HD.emit(MessageEventKind.EventName.SELECT_CONCUBINE_PAUSE_STATUS,false);
        this.node.destroy();
        this.node.removeFromParent();
    }

}
